import { render, staticRenderFns } from "./ListClassroom.vue?vue&type=template&id=2023fdb4&scoped=true"
import script from "./ListClassroom.vue?vue&type=script&lang=js"
export * from "./ListClassroom.vue?vue&type=script&lang=js"
import style0 from "./ListClassroom.vue?vue&type=style&index=0&id=2023fdb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2023fdb4",
  null
  
)

export default component.exports